import type { FC, ReactNode } from "react"

import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

interface CreditApplicationWarningProps {
  title?: string
  children: ReactNode
  className?: string
}

export const CreditApplicationWarning: FC<CreditApplicationWarningProps> = ({
  title = `Credit Application Unavailable`,
  children,
  className = `mx-6`,
}) => {
  return (
    <div
      className={`${className} mt-4 rounded border-l-4 border-amber-400 bg-amber-50 p-4`}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-5 w-5 text-amber-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-amber-800">{title}</h3>
          <p className="mt-1 text-sm text-amber-700">{children}</p>
        </div>
      </div>
    </div>
  )
}
